import React, { useState, useEffect } from "react";
import {
  Stack,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Button,
} from "@mui/material";
import ReactApexChart from "react-apexcharts"; // Make sure to import ReactApexChart
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";
import {
  GET_BILLING_TREND_MOVING_AVERAGE_GRAPH,
  GET_CUSTOMER_BROKER_STATISTICS_LIST,
} from "../../constants/ApiRoute";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NoRecordFound from "../comman/NoRecordFound";

import downloadIcon from "../../images/download-icon.svg";

export default function BillingTrendGraph(props) {
  const { headerTab, customerTab, brokerTab, selectedBroker, setResetvalue, brokerDropDownList, resertValue } = props;
  console.log(selectedBroker, 'selectedBrokerselectedBroker')
  console.log(brokerDropDownList, 'brokerDropDownListselectedBrokerselectedBroker')
  console.log(resertValue, "kjskalkajsjfdaks");

  let downloadFileName = 'Dashboard_Billing_Trend';

  if (!brokerTab?.customerId && !brokerTab?.projectId && brokerTab?.brokerId) {
    downloadFileName = `${selectedBroker?.BrokerName?.replace(/[^a-zA-Z0-9_ ]/g, '')?.replace(/ /g, '_')}_Dashboard_Billing_Trend`
  
  }

  const navigate = useNavigate();
  const [billingTrendandMovingAverage, setBillingTrendandMovingAverage] =
    useState([]);
  const [seriess, setSeriess] = useState([]);
  const [graphConfig, setGraphConfig] = useState({});
  const [brokerHeaderStatistic, setBrokerHeaderStatistic] = useState({
    UserID: "",
    BrokerName: "",
    Email: "",
    ProjCount: "",
    OutstandingTotal: "",
    StmtOpenCount: "",
    StmtClosedCount: "",
    StmtLateCount: "",
    LastActive: "",
  });

  const customDownloadFunction = () => {
    const svgItem = document.querySelector('.exportSVG');
    const csvItem = document.querySelector('.exportCSV');
        if (svgItem) svgItem.remove();
        if (csvItem) csvItem.remove();
  }

  const getBillingTrendandMovingAverage = async () => {

    //Default Zoom Start
    const today = new Date(); // Current date
    const endDate = today; // Set end date to current date
    const startDate = new Date(today); // Create a new date object for the start date
    startDate.setDate(today.getDate() - 30);
    //Default Zoom End

    let data = {
      brokerId: "",
      periodInMonths: 7,
      projectId: "-1",
    };

    if (!brokerTab.customerId && !brokerTab.projectId && brokerTab.brokerId) {
      data.brokerId = brokerTab.brokerId;
    }

    if (headerTab == "Customers") {
      data.brokerId = "";
    }

    const config = {
      method: "GET",
      url: GET_BILLING_TREND_MOVING_AVERAGE_GRAPH,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        setBillingTrendandMovingAverage(data);
        const seriesValue = processGraphData(data);
        setSeriess(seriesValue);

        // const graphConfig = {
        //   chart: {
        //     height: 380,
        //     width: "100%",
        //     type: "line",
        //     animations: {
        //       initialAnimation: {
        //         enabled: false,
        //       },
        //     },
        //   },
        //   stroke: {
        //     curve: "smooth",
        //   },
        //   series: seriesValue,
        //   xaxis: {
        //     type: "datetime",
        //   },
        // };

        const graphConfig = {
          chart: {
            height: 400,
            width: "100%",
            type: "line",
            animations: {
              initialAnimation: {
                enabled: false,
              },
            },
            toolbar: {
              show: true, // Keep the toolbar visible
              tools: {
                download: `<div id="custom-download-icon" title="Download"><img src=${downloadIcon} /></div>`, 
              },
              export: {
                png: {
                  filename: downloadFileName,
                }
              }
            },
            events: {
              click: function() {
                // Call your custom function when download is clicked
                customDownloadFunction();
              },
            },
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          series: seriesValue, // Set series data directly from data array
          xaxis: {
            type: "datetime",
            title: {
              text: "Date", // Set the x-axis title
              style: {
                fontSize: '12px',
                fontWeight: 'normal'
              },
            },

            labels: {
              formatter: function (value) {
                // Convert the timestamp to a UTC date string in 'MM/DD/YYYY' format
                const date = new Date(value);
                return date.toLocaleDateString('en-US', { timeZone: 'UTC' });
              },
            },
            tickAmount: 12,
            min: startDate.getTime(), // Set minimum x-axis value for zoom
            max: endDate.getTime(), // Set maximum x-axis value for zoom

          },
          yaxis: [
            {
              seriesName: ["Hours", "Moving Avg (Hrs)"],
              opposite: true,
              title: {
                text: "Total Hours",
                style: {
                  fontSize: '12px',
                  fontWeight: 'normal',
                },
              },
              labels: {
                formatter: function (val) {
                  return val?.toFixed(2);
                },
              },
            },
            {
              
              title: {
                text: "Total $ Billed",
                style: {
                  fontSize: '12px',
                  fontWeight: 'normal',
                },
              },
              labels: {
                formatter: function (val) {
                  //return val;
                  return `$${val}`;
                },
              },
            },
          ],
          tooltip: {
            y: {
              formatter: function (val) {
                return val?.toFixed(2);
              }
            }
          },
          grid: {
            show: true,
            borderColor: "#f9f9f9",
            strokeDashArray: 5, // Make the lines dotted
            // xaxis: {
            //   lines: {
            //     show: true
            //   }
            // },
            yaxis: {
              lines: {
                show: true,
              },
            },
            opacity: 0.1, // Lower the opacity
          },
        };

        setGraphConfig(graphConfig);

        console.log("seriesValue", seriesValue);
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    }
  };

  // Process data to match chart requirements
  const processGraphData = (data) => {
    console.log(data,'datatattatatatatat')
    var output = [];
    ["Hours", "MovingAvgHours", "Total", "MovingAvgTotal"].forEach(function (
      prop
    ) {

      let nameValue = prop.replace(/([A-Z])/g, " $1").trim();
      
      if(prop == 'MovingAvgHours'){
        nameValue = 'Moving Avg (Hrs)'
      }else if(prop == 'Total'){
        nameValue = 'Total $'
      }else if(prop == 'MovingAvgTotal'){
        nameValue = 'Moving Avg (Total $)'
      }
     
      var series = {
        name: nameValue, 
        data: data.map(function (item, index) {
          const date = new Date(item.Date);
          // Format the date in UTC to avoid local timezone differences
          const formattedDate = date.toISOString().split("T")[0]; // 'YYYY-MM-DD' format in UTC
        
          if (index === data.length - 1) {
            return {
              x: `${formattedDate}T23:59:00.000Z`, // Last date time in UTC
              y: parseFloat(item[prop]).toFixed(2), // Get the corresponding value and format it to 2 decimal places
            };
          } else {
            return {
              x: `${formattedDate}T00:00:00.000Z`, // Date in UTC without local timezone
              y: parseFloat(item[prop]).toFixed(2), // Get the corresponding value
            };
          }
        }),
        
        
        // data: data.map((item, index) => {
        //   const date = new Date(item.Date);
          
        //   return {
        //     x: index === data.length - 1
        //       ? date.toISOString().split("T")[0] + "T23:59:00.000Z" // UTC for last date time
        //       : date.toISOString().split("T")[0] + "T00:00:00.000Z", // UTC for other dates
        //     y: item[prop].toFixed(2) // Get the corresponding value
        //   };
        // })
      };
      if(nameValue == 'Hours'){
        series.yAxisIndex = 0;
      }else{
        series.yAxisIndex = 1;
      }
      
      output.push(series);
    });

    return output;
  };

  const getBrokerHeaderStatistics = async () => {
    const config = {
      method: "GET",
      url: GET_CUSTOMER_BROKER_STATISTICS_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ userId: brokerTab.brokerId })),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("parsedResponse broker count -> ", parsedResponse);

      const { status, data } = parsedResponse;
      if (status === "Success") {
        if (data && data[0]) {
          setBrokerHeaderStatistic(data[0]);
        }
      }
    } catch (error) {
      console.log(" Error Meassage For Statistic", error);
    }
  };

  const handleManageButton = () => {
    navigate(`/user-details/${brokerTab?.brokerId}`);
    localStorage.setItem("DASHBOARD_NAVI", true);
  };

  // const graphConfig = {
  //   chart: {
  //       height: 350,
  //       type: 'line',
  //       stacked: true,
  //         toolbar: {
  //           show: true
  //         },
  //       zoom: {
  //           enabled: false
  //       }
  //   },
  //   dataLabels: {
  //       enabled: false
  //   },
  //   stroke: {
  //       curve: 'smooth'
  //   },
  //   title: {
  //       text: 'Product Trends by Date',
  //       align: 'left'
  //   },
  //   grid: {
  //       row: {
  //           colors: ['#f3f3f3', 'transparent'],
  //           opacity: 0.5
  //       },
  //   },
  //   xaxis: {
  //       categories: xaxisCategories
  //   }
  // };

  // const graphConfig = {
  //   chart: {
  //       height: 350,
  //       type: 'line',
  //       stacked: true,
  //       zoom: {
  //           enabled: true // Enable zoom
  //       },
  //       toolbar: {
  //           show: true
  //       }
  //   },
  //   dataLabels: {
  //       enabled: false
  //   },
  //   stroke: {
  //       curve: 'smooth'
  //   },
  //   title: {
  //       text: 'Product Trends by Date',
  //       align: 'left'
  //   },
  //   grid: {
  //       row: {
  //           colors: ['#f3f3f3', 'transparent'],
  //           opacity: 0.5
  //       },
  //   },
  //   xaxis: {
  //       categories: xaxisCategories,
  //       labels: {
  //           rotate: -45,
  //           style: {
  //               fontSize: '10px'
  //           }
  //       },
  //       type: 'datetime' // Optional: switch to date-time scale if applicable
  //   },
  //   tooltip: {
  //       shared: true,
  //       intersect: false,
  //       x: {
  //           formatter: (value) => new Date(value).toLocaleDateString() // Date formatting in tooltip
  //       }
  //   }
  // };

  useEffect(() => {
    getBillingTrendandMovingAverage();
  }, []);
  useEffect(() => {
    getBrokerHeaderStatistics();
    getBillingTrendandMovingAverage();
  }, [brokerTab.brokerId, customerTab?.customerId]);
  console.log('brokerssss',brokerTab,headerTab,customerTab)
  useEffect(() => {
    getBillingTrendandMovingAverage();
  }, [headerTab]);

  useEffect(() => {
    if (resertValue) {
      const controller = new AbortController();
      const signal = controller.signal;

      const fetchData = async () => {
        try {
          console.log('APIIIIII');
          await getBillingTrendandMovingAverage({ signal });
          console.log('APIIIIII');
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Fetch error:', error);
          }
        }
      };

      fetchData();

      return () => {
        controller.abort();
      };
    }
  }, [resertValue, customerTab?.customerId, brokerTab.customerId]);

  return (
    <>
      {!brokerTab.customerId &&
      (!brokerTab.projectId)&&
      (brokerTab.brokerId || !brokerTab.brokerId) &&
      !customerTab.customerId &&
      !customerTab.projectId &&
      !customerTab.brokerId &&
      graphConfig &&
      graphConfig.chart ? (
        <Box className="bg-box user-log" sx={{ mt: "0px", mr: "9.5px" }}>
          {/* Broker Statustics Start */}
          {headerTab == "Brokers" && brokerTab.brokerId ? (
            <>
              <Stack
                sx={{ mb: "14px" }}
                direction={{ xs: "column", sm: "row", md: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "baseline", sm: "center" }}
              >
                <Typography className="dashboard-title">
                  {selectedBroker?.BrokerName}
                </Typography>
                <Grid sx={{ display: "flex", gap: "17px" }}>
                  {brokerTab?.brokerId != "" ? (
                    <Button className="reset-btn" onClick={handleManageButton}>
                      Manage
                    </Button>
                  ) : (
                    ""
                  )}
                </Grid>
              </Stack>
              <Stack
                sx={{ mb: "28px" }}
                className="broker-count-box"
                direction={{ xs: "column", sm: "row", md: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "baseline", sm: "center" }}
              >
                <Box>
                  <Typography className="br-title">Projects</Typography>
                  <Typography className="br-text">
                    {brokerHeaderStatistic.ProjCount
                      ? brokerHeaderStatistic.ProjCount
                      : 0}{" "}
                    active
                  </Typography>
                </Box>
                <Box>
                  <Typography className="br-title">Billing Total</Typography>
                  <Typography className="br-text">
                    {" "}
                    $
                    {brokerHeaderStatistic.OutstandingTotal
                      ? brokerHeaderStatistic.OutstandingTotal.toFixed(2)
                      : 0.0}
                  </Typography>
                </Box>
                <Box>
                  <Typography className="br-title">Open Stmts</Typography>
                  <Typography className="br-text">
                    {brokerHeaderStatistic.StmtOpenCount
                      ? brokerHeaderStatistic.StmtOpenCount
                      : 0}{" "}
                    open
                  </Typography>
                </Box>
                <Box>
                  <Typography className="br-title">Closed Stmts</Typography>
                  <Typography className="br-text">
                    {brokerHeaderStatistic.StmtClosedCount
                      ? brokerHeaderStatistic.StmtClosedCount
                      : 0}{" "}
                    closed
                  </Typography>
                </Box>
                <Box>
                  <Typography className="br-title">Late Stmts</Typography>
                  <Typography className="br-text">
                    {brokerHeaderStatistic.StmtLateCount
                      ? brokerHeaderStatistic.StmtLateCount
                      : 0}{" "}
                    late
                  </Typography>
                </Box>
                <Box>
                  <Typography className="br-title">Last Active</Typography>
                  <Typography className="br-text">
                    {brokerHeaderStatistic.LastActive
                      ? brokerHeaderStatistic.LastActive
                      : ""}
                  </Typography>
                </Box>
              </Stack>
            </>
          ) : (
            ""
          )}
          {/* Broker Statustics End */}

          <Stack
            direction={{ xs: "column", sm: "row", md: "row" }}
            justifyContent="space-between"
            alignItems="baseline"
          >
            <Typography className="dashboard-title">
              Billing Trend w/ Moving Average{" "}
            </Typography>

            {/* <Box>
              <Box className="chart-checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      label="Hours"
                      defaultChecked
                      sx={{
                        color: "#8280FF !important",
                        "&.Mui-checked": {
                          color: "#8280FF !important",
                        },
                      }}
                    />
                  }
                  label="Hours"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      label="Hours"
                      defaultChecked
                      sx={{
                        color: "#FF9900 !important",
                        "&.Mui-checked": {
                          color: "#FF9900 !important",
                        },
                      }}
                    />
                  }
                  label="Moving Average (Hours)"
                />
              </Box>
              <Box className="chart-checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked
                      sx={{
                        color: "#EF665B !important",
                        "&.Mui-checked": {
                          color: "#EF665B !important",
                        },
                      }}
                    />
                  }
                  label="Total $ "
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      defaultChecked
                      sx={{
                        color: "#58A84A !important",
                        "&.Mui-checked": {
                          color: "#58A84A !important",
                        },
                      }}
                    />
                  }
                  label="Moving Average (Total $)"
                />
              </Box>
            </Box> */}
          </Stack>
{console.log('series',seriess,seriess&&seriess.length,graphConfig)}
          {seriess && seriess.length > 0 ? (

          <div className="responsive-chart" id="chart">
            <ReactApexChart
              options={graphConfig}
              series={seriess}
              type="line"
              height={350}
            />
          </div>

          ) : (
          <NoRecordFound/>
          )}

        </Box>
      ) : (
        ""
      )}
    </>
  );
}
